import { FilterMatchMode } from "primereact/api";

export class Control {
    model = {
        id: { value: null, export: false },
        idp: { value: null, export: false },
        implementado: {
            value: null, header: 'CONTROLES IMPLEMENTADOS (EXISTENTES) (APLICA PARA OPCIONES DE TRATAMIENTO DIFERENTES A RETENER EL RIESGO)', required: 'Campo requerido', table: true,
            matchMode: FilterMatchMode.CONTAINS, filterField: 'implementado', filter: true, filterPlaceholder: 'Búsqueda', sort: true
        },
        responsable: { header: 'RESPONSABLE(S) DE EJECUCIÓN DE CONTROL (APLICA PARA OPCIONES DE TRATAMIENTO DIFERENTES A ACEPTAR EL RIESGO)',
            value: null, required: 'Selecione una opcion', optionLabel: 'nombre', table: true, filterPlaceholder: 'Búsqueda', filterField: 'responsable',
            filter: true, sort: true, matchMode: FilterMatchMode.CONTAINS
        },
        tipo_control: {
            header: 'TIPO DE CONTROL', value: null, required: 'Selecione una opcion', optionLabel: 'nombre', table: true,
            filterPlaceholder: 'Búsqueda', filterField: 'tipo_control', filter: true, sort: true, matchMode: FilterMatchMode.CONTAINS
        },
        ejecucion: {
            header: 'TIPO DE EJECUCIÓN DE CONTROL', value: null, required: 'Seleccione una opción', optionLabel: 'nombre', table: true,
            filterPlaceholder: 'Búsqueda', filterField: 'ejecucion', filter: true, sort: true, matchMode: FilterMatchMode.CONTAINS
        },
        frecuencia: {
            header: 'FRECUENCIA DEL CONTROL', value: null, required: 'Seleccione una opción', optionLabel: 'nombre', table: true,
            filterPlaceholder: 'Búsqueda', filterField: 'frecuencia', filter: true, sort: true, matchMode: FilterMatchMode.CONTAINS
        },
        solidez: {
            header: 'SOLIDEZ DE LOS CONTROLES', value: null, required: false, optionLabel: 'nombre', export: true, table: true,
            filterPlaceholder: 'Búsqueda', filterField: 'solidez', filter: true, sort: true, matchMode: FilterMatchMode.CONTAINS
        },
        efectividad: {
            header: 'EFECTIVIDAD DE LA IMPLEMENTACIÓN DE LOS CONTROLES', value: null, table: true, export: true,
            filterPlaceholder: 'Búsqueda', filterField: 'efectividad', filter: true, sort: true, matchMode: FilterMatchMode.CONTAINS
        },
    }
}
